import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"

import Column from "../../common/components/Column"
import Row from "../../common/components/Row"
import { formatTalkTime } from "../customer/activity/formatTalkTime"

export const readOnlyCapsuleFieldProps = {
  InputProps: {
    readOnly: true,
    tabIndex: -1,
    endAdornment: (
      <InputAdornment position="end">
        <LockOutlinedIcon fontSize="small" color="disabled" />
      </InputAdornment>
    ),
  },
}

function formatFieldValue(value) {
  if (value === null || value === undefined) {
    return "0"
  }
  return String(value)
}

export default function ActivityReportFormFields({
  form,
  notes = "",
  onNotesChange,
  notesReadOnly = false,
  showReportDate = false,
}) {
  if (!form) {
    return null
  }

  return (
    <Column gap={2.5}>
      <TextField
        label="Notes from the session:"
        placeholder={
          notesReadOnly
            ? undefined
            : "Short notes about your session for the client."
        }
        value={notes}
        onChange={
          notesReadOnly
            ? undefined
            : (event) => onNotesChange?.(event.target.value)
        }
        multiline
        minRows={4}
        fullWidth
        InputProps={notesReadOnly ? { readOnly: true } : undefined}
      />
      <Column gap={1.5}>
        <Typography variant="subtitle2" color="secondary">
          Concierge&apos;s name *
        </Typography>
        <Row gap={2}>
          <TextField
            label="First Name"
            value={form.concierge_first_name || ""}
            fullWidth
            {...readOnlyCapsuleFieldProps}
          />
          <TextField
            label="Last Name"
            value={form.concierge_last_name || ""}
            fullWidth
            {...readOnlyCapsuleFieldProps}
          />
        </Row>
      </Column>
      <TextField
        label="Concierge's Email *"
        value={form.concierge_email || ""}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Client Name *"
        value={form.client_name || ""}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      {showReportDate ? (
        <TextField
          label="Report date *"
          value={form.report_date || ""}
          fullWidth
          {...readOnlyCapsuleFieldProps}
        />
      ) : null}
      <TextField
        label="Total dialer sessions *"
        value={formatFieldValue(form.total_dialer_sessions)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Total active minutes *"
        value={formatFieldValue(form.active_minutes)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Total number of calls *"
        value={formatFieldValue(form.total_calls)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Talk Time *"
        value={formatTalkTime(form.total_talk_seconds)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Total connected *"
        value={formatFieldValue(form.total_connections)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Conversations 30+ seconds *"
        value={formatFieldValue(form.conversations_30_seconds)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Total number of bookings *"
        value={formatFieldValue(form.total_bookings)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Voicemails left *"
        value={formatFieldValue(form.voicemails_left)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Texts sent *"
        value={formatFieldValue(form.texts_sent)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Texts received *"
        value={formatFieldValue(form.texts_received)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
      <TextField
        label="Dialing hours *"
        value={formatFieldValue(form.dialing_hours)}
        fullWidth
        {...readOnlyCapsuleFieldProps}
      />
    </Column>
  )
}
